import { useState, useEffect } from 'react';

/**
 * Custom hook to detect RTL (Right-to-Left) mode
 * Returns boolean indicating if document direction is RTL
 * Listens for changes to document.documentElement.dir attribute
 */
export function useRTL(): boolean {
  const [isRTL, setIsRTL] = useState(() => {
    return document.documentElement.dir === 'rtl';
  });

  useEffect(() => {
    // Create observer to watch for dir attribute changes
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'dir') {
          const newDir = document.documentElement.dir;
          setIsRTL(newDir === 'rtl');
        }
      });
    });

    // Observe the documentElement for attribute changes
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['dir'],
    });

    // Cleanup observer on unmount
    return () => {
      observer.disconnect();
    };
  }, []);

  return isRTL;
}
